import React from 'react';
import { toast } from 'sonner';
import { MapPinIcon, PhoneIcon, MailIcon, LinkedinIcon, FileDownIcon } from 'lucide-react';
import { ContactForm } from '../components/sections/ContactForm';
import { Button } from '../components/ui/Button';
export function ContactPage() {
  const handleDownload = (label: string) => {
    toast.success(`${label} request received`, {
      description: 'This document will be sent to your email shortly.'
    });
  };
  return <section className="bg-navy py-16 lg:py-24" data-id="element-220" data-mp="11g28dga488a">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-221" data-mp="51q53h8ryiix">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-10" data-id="element-222" data-mp="9zrpq6lumpwi">
          <div className="lg:col-span-5" data-id="element-223" data-mp="a1unjct8tnbs">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brandgreen-light" data-id="element-224" data-mp="eze3qi9i4a6d">
              Board Inquiry &amp; Direct Contact Portal
            </p>
            <h1 className="mt-3 font-heading text-3xl font-semibold text-white sm:text-4xl" data-id="element-225" data-mp="1lhb0ql5o7x5m">
              Direct Executive Contact &amp; Advisory Inquiry
            </h1>

            <div className="mt-10 space-y-5 border-t border-white/10 pt-8" data-id="element-226" data-mp="qzvnikgcc7x3">
              <div className="flex items-start gap-3" data-id="element-227" data-mp="n0egvnp6h4qc">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-brandgreen-light" aria-hidden="true" data-id="element-228" data-mp="i00aea3862uf" />
                <span className="text-sm text-slate-300" data-id="element-229" data-mp="d15ogz9yny63">Richmond Heights, MO 63117</span>
              </div>
              <div className="flex items-start gap-3" data-id="element-230" data-mp="82ce3fpz0na5">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-brandgreen-light" aria-hidden="true" data-id="element-231" data-mp="83x5iwgznq3s" />
                <a href="tel:+13145701462" className="text-sm text-slate-300 transition-colors duration-150 hover:text-white" data-id="element-232" data-mp="399fgt6c6nn3">
                  (314) 570-1462
                </a>
              </div>
              <div className="flex items-start gap-3" data-id="element-233" data-mp="3lfnqokd80jhs">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-brandgreen-light" aria-hidden="true" data-id="element-234" data-mp="3ghm9k4zcuu8y" />
                <div className="text-sm text-slate-300" data-id="element-235" data-mp="36u06x0axjgzg">
                  <a href="mailto:gerson.eli@gmail.com" className="transition-colors duration-150 hover:text-white" data-id="element-236" data-mp="36sfd5cwfw22n">
                    gerson.eli@gmail.com
                  </a>
                  <span className="mx-2 text-slate-600" data-id="element-237" data-mp="31uxd6c0egx6s">|</span>
                  <a href="mailto:egerson@ameren.com" className="transition-colors duration-150 hover:text-white" data-id="element-238" data-mp="31v73k0pcx6d0">
                    egerson@ameren.com
                  </a>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap gap-3 border-t border-white/10 pt-8" data-id="element-239" data-mp="3grockla2q8we">
              <Button variant="outline-light" href="https://www.linkedin.com/in/gersoneli/" external data-id="element-240" data-mp="3ksgnrk2ianvb">
                <LinkedinIcon className="h-4 w-4" aria-hidden="true" data-id="element-241" data-mp="cd6ftvbxqofm" />
                LinkedIn Profile
              </Button>
              <Button variant="ghost-light" onClick={() => handleDownload('Resume')} data-id="element-242" data-mp="h6sutu5kn4el">
                <FileDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-243" data-mp="21tae56gpoitq" />
                Download Resume
              </Button>
              <Button variant="ghost-light" onClick={() => handleDownload('Official Clarification Statement')} data-id="element-244" data-mp="1wu62882ek6zp">
                <FileDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-245" data-mp="26m3ivuc6jr5t" />
                Download Official Clarification Statement
              </Button>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-246" data-mp="1iy2d2t6dyou3">
            <ContactForm data-id="element-247" data-mp="1dy7oiwa32bc7" />
          </div>
        </div>
      </div>
    </section>;
}